<template>
  <div class="text-slate-800">
    <Topbar />
    <Header />
    <slot />
    <Footer />
  </div>
</template>
